module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAgUlEQVQ4T93SPQqDQBCG4cciQchJUuYGloJVwE48TeocJIVNGjvPZRm2EGSJq2LnlrPzvfPzTebgyw7qnRDwwAs1xmg/JRq083i8gyu+uKCaQYL4gyeGFCD8xZBiSRySl1wIkB433P9VnrpI2Zijwztue22EXbd1wkPaNX/Kxs2gHzStDhGB4694AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/icon-down.png
// module id = mV4e
// module chunks = 0